import { InfoRounded } from "@mui/icons-material";

type HelpButtonProps = {
  title: string;
  onClick: () => void;
  id?: string;
};

const HelpButton = ({ title, onClick, id }: HelpButtonProps): JSX.Element => {
  return (
    <button
      id={id}
      onClick={onClick}
      type="button"
      title={title}
      aria-label={title + " mer info"}
      className="w-15 h-15 bg-ldir-blue-800 rounded-xl text-ldir-blue-100"
    >
      <InfoRounded className="h-10 w-10" />
    </button>
  );
};

export default HelpButton;
